<template>
  <div class="api-item" v-if="item">
    <img
      class="api-item-image"
      :src="item.imgUrl"
      :alt="item.name"
      :title="item.name"
    />
    <p class="api-item-name">{{ item.name }}</p>
    <div class="api-item-desc">
      {{ item.remark }}
    </div>
    <!-- <span class="api-item-price">¥0.009/次</span> -->
    <button class="api-item-btn" @click="applyData(item.id)">申请数据</button>
  </div>
</template>

<script>
export default {
  methods: {
    applyData (id) {
      this.$router.push('/apiMargetDetail/' + id)
    }
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.api-item {
  width: 232px;
  height: 240px;
  border: 1px solid #eee;
  border-radius: 4px;
  margin: 0 9px 22px;
  text-align: center;
  padding-top: 20px;
  position: relative;

  .api-item-image {
    width: 50px;
    height: 50px;
    object-fit: contain;
  }

  .api-item-price {
    color: #ff4d4f;
    font-size: 16px;
    padding-top: 10px;
  }

  .api-item-name {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .api-item-desc {
    padding: 8px 14px 0;
    font-size: 12px;
    color: #999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .api-item-btn {
    position: absolute;
    left: 10%;
    bottom: 20px;
    width: 80%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #00bdff;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
    border: none;
  }
}
</style>
